import React, { FC, Fragment } from 'react';
import { useQuery } from '@apollo/client';
import { list } from '../../../graph/physicians';
import MultiSelectInput from '@/se/components/inputs/MultiSelectInput';

const PhysicianMultiSelectInput: FC<any> = ({ value, onChange }) => {
  const { data, loading } = useQuery(list);

  if (loading) return null;

  const options = (data?.physicians || [])
    .map((e: any) => ({
      label: e.name,
      value: e.id,
    }))
    .sort((a: any, b: any) => String(a.label).localeCompare(String(b.label)));

  const transformedValue = options.filter((e: any) => (value || []).includes(e.value));

  return (
    <Fragment>
      <MultiSelectInput
        name={'physicians-select'}
        options={options}
        onChange={(updated: any) => {
          onChange(updated?.map((e: any) => e.value));
        }}
        value={transformedValue}
        loading={false}
        disabled={false}
      />
    </Fragment>
  );
};

export default PhysicianMultiSelectInput;
